<div class="modal-header border-0 completion-modal-header text-white">
  <div class="d-flex align-items-center w-100 justify-content-center">
    <div class="completion-icon me-3">
      <i class="fa fa-trophy"></i>
    </div>
    <div class="text-center">
      <h4 class="modal-title mb-1">{{ 'COMPLETION.MODAL_TITLE' | translate }}</h4>
      <p class="mb-0 opacity-75">{{ 'COMPLETION.MODAL_SUBTITLE' | translate }}</p>
    </div>
  </div>
</div>

<div class="modal-body p-4 text-center">
  <!-- Celebration Animation -->
  <div class="celebration-icon mb-4">
    <i class="fa fa-check-circle text-success"></i>
  </div>
  
  <!-- Completion Stats -->
  <div class="completion-stats mb-4">
    <h5 class="text-success mb-3">{{ 'COMPLETION.CONGRATULATIONS' | translate }}</h5>
    <p class="text-muted mb-3">{{ 'COMPLETION.ALL_CLASSES_COMPLETE' | translate }}</p>
    
    <div class="stats-grid row">
      <div class="col-6">
        <div class="stat-item">
          <div class="stat-number">{{ stats?.classesCompleted || 10 }}</div>
          <div class="stat-label">{{ 'COMPLETION.CLASSES_COMPLETED' | translate }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="stat-item">
          <div class="stat-number">{{ stats?.totalClasses || 10 }}</div>
          <div class="stat-label">{{ 'COMPLETION.TOTAL_CLASSES' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Certificate Info -->
  <div class="certificate-info-card">
    <div class="d-flex align-items-center justify-content-center mb-3">
      <i class="fa fa-certificate text-warning me-2"></i>
      <span class="fw-bold">{{ 'COMPLETION.CERTIFICATE_READY' | translate }}</span>
    </div>
    <p class="text-muted small mb-0">{{ 'COMPLETION.CERTIFICATE_DESCRIPTION' | translate }}</p>
  </div>
</div>

<div class="modal-footer border-0 justify-content-center">
  <div class="d-grid gap-2 d-md-flex justify-content-md-center w-100">
    <button
      type="button"
      class="btn btn-success btn-lg px-4"
      (click)="goToCertificate()">
      <i class="fa fa-download me-2"></i>
      {{ 'COMPLETION.GET_CERTIFICATE' | translate }}
    </button>
    
    <button
      type="button"
      class="btn btn-outline-secondary px-4"
      (click)="close()">
      {{ 'COMPLETION.CLOSE' | translate }}
    </button>
  </div>
</div>